/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import { Card } from '@mui/material';
import Chart, { useChart } from '../../../components/chart';

const CHART_SIZE = { height: 300 };

export default function CreditScore({ score, thresholds }) {
  const theme = useTheme();
  console.log('Se recibe este dato: ', thresholds);
  const sections = thresholds;
  console.log('Número de secciones:', sections);
  console.log('Score:', score);

  const colorMap = {
    DENEGAR: theme.palette.red.main,
    REVISAR: theme.palette.warning.light,
    OK: theme.palette.tertiary.main,
  };

  console.log('Thresholds:', thresholds);
  console.log('test:', score, sections);
  const scorePercentage = (score / sections) * 100;
  console.log('Porcentaje de score:', scorePercentage);

  let currentColor;

  if (scorePercentage < 40) {
    currentColor = colorMap.DENEGAR;
  } else if (scorePercentage < 60) {
    currentColor = colorMap.REVISAR;
  } else {
    currentColor = colorMap.OK;
  }

  console.log('Mapa de colores:', colorMap);
  console.log('Color actual:', currentColor);

  const chartOptionsCheckIn = useChart({
    chart: {
      offsetY: -10,
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          strokeWidth: '97%',
          margin: 5,
          color: theme.palette.grey[300],
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: '1.2em',
            formatter: () => {
              if (scorePercentage < 40) return 'RECHAZAR';
              if (scorePercentage < 60) return 'REVISAR';
              return 'APROBAR';
            },
            offsetY: 20,
            offsetX: 0,
            color: currentColor,
          },
          value: {
            show: true,
            formatter: () => `${score}`,
            fontSize: '3em',
            fontWeight: 600,
            offsetY: -30,
            offsetX: 0,
          },
          total: {
            show: false,
          },
        },
        grid: {
          padding: {
            top: 30,
            bottom: -20,
          },
        },
      },
    },
    grid: {
      padding: {
        top: -40,
      },
    },
    fill: {
      type: 'solid',
      colors: [currentColor],
    },
    legend: {
      show: false,
    },
  });

  return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Chart
            type="radialBar"
            series={[scorePercentage]}
            options={chartOptionsCheckIn}
            {...CHART_SIZE}
          />
      </Box>
    
  );
}

CreditScore.propTypes = {
  score: PropTypes.number.isRequired,
  thresholds: PropTypes.number,
};
